<app-header></app-header>
<div class="page-content d-flex align-items-center justify-content-center">
  @if (!registrationSuccess) {
    <div class="card col-11 col-lg-5 shadow rounded p-4 border-0">
      <div class="card-body p-0">
        <h5 class="card-title text-center mb-4">{{ 'sign_up' | transloco }}</h5>
        <div class="mt-2 mb-2">
          <span class="text-center">{{ selectedProgramTitle }}</span>
          @if (programsInBasket && programsInBasket > 1) {
            <span>{{ 'and_others' | transloco }}</span>
          }
        </div>
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="row g-3">
          <div class="col-12">
            <div class="input-group">
              <span class="input-group-text">
                <i class="bi bi-person"></i>
              </span>
              <div class="form-floating">
                <input
                  type="text"
                  class="form-control"
                  id="firstName"
                  formControlName="firstName"
                  placeholder="{{ 'first_name' | transloco }}"
                  [class.is-invalid]="form.controls['firstName'].invalid && form.controls['firstName'].touched"
                />
                <label for="firstName" [appRequiredAsterisk]="'first_name'" [formGroup]="form">{{
                  'first_name' | transloco
                }}</label>
              </div>
              @if (form.controls['firstName'].touched && form.controls['firstName'].hasError('required')) {
                <div class="invalid-feedback">
                  {{ 'error.fill_field' | transloco }}
                </div>
              }
            </div>
          </div>
          <div class="col-12">
            <app-input-phone-email formControlName="contact" />
          </div>
          <div class="col-12">
            <div class="input-group mb-3">
              <span class="input-group-text"><i class="bi bi-lock"></i></span>
              <div class="form-floating">
                <input
                  [type]="passwordChecked ? 'text' : 'password'"
                  class="form-control"
                  id="password"
                  formControlName="password"
                  placeholder="{{ 'create_password' | transloco }}"
                  [class.is-invalid]="form.controls['password'].invalid && form.controls['password'].touched"
                />
                <label for="password" [appRequiredAsterisk]="'password'" [formGroup]="form">{{
                  'create_password' | transloco
                }}</label>
              </div>
              <span class="input-group-text">
                <label
                  class="btn btn-outline-secondary"
                  for="togglePassword"
                  (click)="passwordChecked = !passwordChecked"
                >
                  <i class="bi" id="eyeIcon" [class]="passwordChecked ? 'bi-eye' : 'bi-eye-slash'"></i>
                </label>
              </span>
              @if (form.controls['password'].touched && form.controls['password'].hasError('required')) {
                <div class="invalid-feedback">
                  {{ 'error.fill_field' | transloco }}
                </div>
              } @else if (form.controls['password'].touched && form.controls['password'].hasError('passwordInvalid')) {
                <div class="invalid-feedback">
                  {{ 'error.password' | transloco }}
                </div>
              }
            </div>
          </div>

          <div class="col-12">
            <div class="input-group mb-3">
              <span class="input-group-text"><i class="bi bi-lock"></i></span>
              <div class="form-floating">
                <input
                  [type]="passwordChecked ? 'text' : 'password'"
                  class="form-control"
                  id="repeatPassword"
                  formControlName="repeatPassword"
                  placeholder="{{ 'repeat_password' | transloco }}"
                  [class.is-invalid]="
                    form.controls['repeatPassword'].invalid && form.controls['repeatPassword'].touched
                  "
                />
                <label for="repeatPassword" [appRequiredAsterisk]="'repeatPassword'" [formGroup]="form">{{
                  'repeat_password' | transloco
                }}</label>
              </div>
              <span class="input-group-text">
                <label
                  class="btn btn-outline-secondary"
                  for="togglePassword"
                  (click)="passwordChecked = !passwordChecked"
                >
                  <i class="bi" id="eyeIcon" [class]="passwordChecked ? 'bi-eye' : 'bi-eye-slash'"></i>
                </label>
              </span>
              @if (form.controls['repeatPassword'].touched && form.controls['repeatPassword'].hasError('required')) {
                <div class="invalid-feedback">
                  {{ 'error.fill_field' | transloco }}
                </div>
              } @else if (form.hasError('passwordMismatch')) {
                <div class="invalid-feedback d-block">
                  {{ 'error.password_repeat' | transloco }}
                </div>
              }
            </div>
          </div>

          <a class="mt-3 cursor text-black-50 text-center" (click)="openModal()">{{ 'info_processing' | transloco }}</a>
          <button type="submit" class="btn btn-primary w-100 mt-4" [disabled]="!form.valid || isLoading">
            @if (isLoading) {
              <span class="spinner-border spinner-border-sm"></span>
            } @else {
              <span>{{ 'sign_up' | transloco }}</span>
            }
          </button>

          <div class="d-flex justify-content-center gap-2">
            <span class="">{{ 'already_registered' | transloco }}</span>
            <a [routerLink]="['/sign-in']" routerLinkActive="router-link-active" class="link-primary">{{
              'sign_in' | transloco
            }}</a>
          </div>
        </form>
      </div>
    </div>
  } @else {
    <app-registration-success></app-registration-success>
  }
</div>
<app-info-processing-modal
  [message]="'info_processing_patient'"
  [title]="'info_processing_patient_title'"
></app-info-processing-modal>
